<template>
  <div>
    <headers />
    <div>
      <router-view />
    </div>
    <footers />
    <!-- 侧边栏 -->
    <div class="rightnav">
      <div class="item">
        <a href="https://mail.sj-hospital.org/" target="_blank">
          <img src="@/assets/icon/01.png" alt="" />
          <div class="tit">
            <div class="middle">
              <div class="middle-cont">
                邮箱<br />
                登录
              </div>
            </div>
          </div>
        </a>
      </div>
      <!-- <div class="item">
        <a href="http://sjsite.k8ser.com/webSite/index" target="_blank">
          <img src="@/assets/icon/09.png" alt="" />
          <div class="tit">
            <div class="middle">
              <div class="middle-cont">
                预约<br />
                挂号
              </div>
            </div>
          </div>
        </a>
      </div> -->
      <div class="item w">
        <a @click="onlilnedialogVisible = true">
          <img src="@/assets/icon/05.png" alt="" />
          <div class="tit">
            <div class="middle">
              <div class="middle-cont">
                手机<br />
                预约
              </div>
            </div>
          </div>
        </a>
      </div>
      <div class="item">
        <a href="/jyzn">
          <img src="@/assets/icon/02.png" alt="" />
          <div class="tit">
            <div class="middle">
              <div class="middle-cont">
                就医<br />
                指南
              </div>
            </div>
          </div>
        </a>
      </div>
      <div class="item">
        <a @click="wxdialogVisible = true">
          <img src="@/assets/icon/03.png" alt="" />
          <div class="tit">
            <div class="middle">
              <div class="middle-cont">
                官方<br />
                微信
              </div>
            </div>
          </div>
        </a>
      </div>
      <div class="item">
        <a @click="appdialogVisible = true">
          <img src="@/assets/icon/04.png" alt="" />
          <div class="tit">
            <div class="middle">
              <div class="middle-cont">
                手机<br />
                APP
              </div>
            </div>
          </div>
        </a>
      </div>
      <div class="item">
        <a href="/ylts/home">
          <img src="@/assets/icon/06.png" alt="" />
          <div class="tit">
            <div class="middle">
              <div class="middle-cont">
                科室<br />
                介绍
              </div>
            </div>
          </div>
        </a>
      </div>
      <div class="item">
        <a href="/ylts/mingyi">
          <img src="@/assets/icon/07.png" alt="" />
          <div class="tit">
            <div class="middle">
              <div class="middle-cont">
                盛京<br />
                名医
              </div>
            </div>
          </div>
        </a>
      </div>
      <div class="item gotop1">
        <a ref="backTop">
          <img src="@/assets/icon/08.png" alt="" />
          <div class="tit">
            <div class="middle">
              <div class="middle-cont">
                返回<br />
                顶部
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <el-dialog
      :visible.sync="onlilnedialogVisible"
      width="75%"
      :append-to-body="true"
      title="手机预约"
    >
      <div v-html="onlilneUrl"></div>
    </el-dialog>
    <el-dialog
      :visible.sync="wxdialogVisible"
      width="75%"
      :append-to-body="true"
      title="官方微信"
    >
      <div v-html="wxUrl"></div>
    </el-dialog>
    <el-dialog
      :visible.sync="appdialogVisible"
      width="75%"
      :append-to-body="true"
      title="手机APP"
    >
      <div v-html="appewmUrl"></div>
    </el-dialog>
  </div>
</template>
<script>
import headers from "../components/header";
import footers from "../components/footer";
import service from "../service/index";
export default {
  inject: ["reload"],
  data() {
    return {
      onlilnedialogVisible: false,
      onlilneUrl: "", //获取网上预约 二维码
      appdialogVisible: false,
      appewmUrl: "", //获取手机APP 二维码
      wxdialogVisible: false,
      wxUrl: "", //获取官方微信 二维码
    };
  },

  methods: {},
  mounted() {
    service.getOnlineInfo({}, (res) => {
      this.onlilneUrl = res.description || "";
    });
    service.getAppInfo({}, (res) => {
      this.appewmUrl = res.description || "";
    });
    service.getWxInfo({}, (res) => {
      this.wxUrl = res.description || "";
    });

    $(function () {
      // -- 侧边栏 --
      $(".gotop1").bind("click", function () {
        $("html,body").animate({ scrollTop: 0 }, 1500);
      });
    });
  },
  components: {
    headers,
    footers,
  },
  computed: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.rightnav {
  position: fixed;
  right: 15px;
  top: 42%;
  width: 70px;
  z-index: 99;
  margin-top: -190px;
  visibility: hidden;
  .item {
    width: 60px;
    height: 60px;
    overflow: hidden;
    background: #fff;
    border-radius: 5px;
    position: relative;
    margin-bottom: 6px;
    -webkit-box-shadow: 0px 0px 59px 0px rgba(19, 40, 83, 0.1);
    box-shadow: 0px 0px 59px 0px rgba(19, 40, 83, 0.1);
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;

    -webkit-box-align: center;
    align-items: center;
    a {
      img {
        width: 40px;
      }
    }
  }
  .item:hover .tit {
    opacity: 1;
  }
  .tit {
    font-size: 14px;
    color: #fff;
    text-align: center;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #00479d;
    line-height: 20px;
    -webkit-transition: opacity 0.4s ease;
    transition: opacity 0.4s ease;
  }
  .middle {
    width: 100%;
    height: 100%;
    .middle-cont {
      display: inline-block;
      vertical-align: middle;
      font-size: 14px;
      letter-spacing: 0;
      margin-top: 10px;
    }
  }
  .gotop1 {
    -webkit-transition: all 0.8s ease;
    transition: all 0.8s ease;
    opacity: 1;
    // -webkit-transform: translateY(50px);
    // transform: translateY(50px);
    visibility: visible;
    cursor: pointer;
  }
}
.gotop1.show {
  -webkit-transform: translateY(0);
  transform: translateY(0);
  opacity: 1;
  visibility: visible;
}
@media only screen and (min-width: 768px) {
  .rightnav {
    visibility: visible;
  }
  .gotop1.show {
    visibility: hidden;
  }
}
@media only screen and (max-width: 1200px) {
  .gotop1 {
    display: none !important;
  }
}
</style>
